import { render, staticRenderFns } from "./TaskTemplateOneItem.vue?vue&type=template&id=eb479086"
import script from "./TaskTemplateOneItem.vue?vue&type=script&lang=js"
export * from "./TaskTemplateOneItem.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplateOneItem.vue?vue&type=style&index=0&id=eb479086&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FProduct%2FOld%2FTaskTemplateOne%2FTaskTemplateOneItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports